import { render } from "./RacesMain.vue?vue&type=template&id=1d3aaa1a&scoped=true"
import script from "./RacesMain.vue?vue&type=script&lang=js"
export * from "./RacesMain.vue?vue&type=script&lang=js"

import "./RacesMain.vue?vue&type=style&index=0&id=1d3aaa1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3aaa1a"]])

export default __exports__